<suite-rfb-collapse [title]="titulo" [collapsed]="collapsed">
  <suite-rfb-alert-messages-with-datetime [onlyFor]="scopeId"></suite-rfb-alert-messages-with-datetime>

  <loading-animation *ngIf="!dadosBasicos"></loading-animation>

  <via-dados-basicos-pf [cpf]="this.cpf"
                        [dadosBasicos]="this.dadosBasicos"
                        [tituloEleitor]="this.tituloEleitor"
                        [isCadeiaNi]="this.isCadeiaNi">
  </via-dados-basicos-pf>
</suite-rfb-collapse>